export default __webpack_public_path__ + "static/media/git.e0d7d725.svg";